import formatDate from "../utils/formatDate";
import candidateInfo from "./candidateInfo";

const formStart = {
  id: candidateInfo?.id,
  name: candidateInfo?.name,
  lastName: candidateInfo?.lastName,
  email: candidateInfo?.email,
  picture_name: candidateInfo?.picture?.filename,
  cvName: candidateInfo?.cvName,
  birthday: candidateInfo?.birthday ? formatDate(candidateInfo?.birthday.date) : "",
  willingToRelocate: candidateInfo?.willingToRelocate ? "1" : "0",
  willingToRelocateInfo: candidateInfo?.willingToRelocateInfo,
  document: candidateInfo?.document,
  documentType: candidateInfo?.documentType ?? candidateInfo?.document?.type,
  documentNumber: candidateInfo?.documentNumber ?? candidateInfo?.document?.number,
  receiveJobOfferNotifications: candidateInfo.receiveJobOfferNotifications ? "1" : "0",
  interestAreas: candidateInfo?.interestAreas,
  sex: candidateInfo?.sex,
  ethnicOrigin: candidateInfo?.ethnicOrigin?.toLowerCase(),
  originCountry: candidateInfo?.originCountry?.toLowerCase(),
  employmentStatus: candidateInfo?.employmentStatus?.toLowerCase(),
  phone: candidateInfo?.phone,
  hasHealthCard: candidateInfo?.hasHealthCard ? "1" : "0",
  healthCardExpiration: candidateInfo?.healthCardExpiration ? formatDate(candidateInfo?.healthCardExpiration.date) : "",
  registeredAsPersonsDisabilities: candidateInfo?.registeredAsPersonsDisabilities ? "1" : "0",
  isForeignWithDocumentInProcess: candidateInfo?.isForeignWithDocumentInProcess ? "1" : "0",
  extraData: {
    registeredOnViaTrabajo: candidateInfo?.extraData?.registeredOnViaTrabajo,
  },
  hasDriveCard: candidateInfo?.driversCard ? "1" : "0",
  driversCard: candidateInfo?.driversCard,
  location: candidateInfo?.location,
  languages: candidateInfo?.languages,
  tertiaryStudies: candidateInfo?.tertiaryStudies,
  firstExperience: candidateInfo.firstExperience ? "1" : "0",
  jobExperiences: candidateInfo?.jobExperiences?.map((jobExperience) => {
    jobExperience.peopleInCharge = jobExperience?.peopleInCharge ? "1" : "0";
    jobExperience.isCurrentlyWorking = jobExperience?.isCurrentlyWorking ? "1" : "0";
    jobExperience.startDate = jobExperience?.startDate ? formatDate(jobExperience?.startDate?.date) : "";
    jobExperience.endDate = jobExperience?.endDate ? formatDate(jobExperience?.endDate?.date) : ""

    return jobExperience
  }),
  isInternalEmployee: candidateInfo?.isInternalEmployee ? candidateInfo?.isInternalEmployee : "0",
  wasEmployee: candidateInfo?.wasEmployee ? candidateInfo?.wasEmployee : "0",
  internalEmployeeData: {
    from: candidateInfo?.internalEmployeeData?.from ? formatDate(candidateInfo?.internalEmployeeData?.from) : "",
    to: candidateInfo?.internalEmployeeData?.to ? formatDate(candidateInfo?.internalEmployeeData?.to) : "",
    area: candidateInfo?.internalEmployeeData?.area || "",
  },
};

export default formStart;
// {
//   "id": "118",
//   "name": "Gustaf",
//   "lastName": "Rodríguez",
//   "email": "gustavguez70@gmail.com",
//   "picture": "",
//   "birthday": {
//       "date": "0001-01-01 00:00:00.000000",
//       "timezone_type": "3",
//       "timezone": "America/Montevideo"
//   },
//   "willingToRelocate": "1",
//   "willingToRelocateInfo": "",
//   "document": "",
//   "phone": "",
//   "hasHealthCard": "",
//   "healthCardExpiration": "",
//   "registeredAsPersonsDisabilities": "",
//   "isForeignWithDocumentInProcess": "",
//   "driversCard": "",

//   "aptitudes": "",
//   "tertiaryStudies": "",
//   "extraData": "",
//   "languages": "",
//   "location": "",
//   "lastSecondaryYear": "0",
//   "cvName": "",
//   "interestAreaYears": "",
//   "interestArea": "",
//   "jobExperiences": []
// }
